module.exports = function(bootstrap) {
	bootstrap.run(["Service", "services", function (Service, services) {
		new Service({
			name: 'tobaccoSave',
			group: "rbsmbl",
			url: "/rbsmbl/x-services/tobacco/familyinfo",
			contentType: 'application/json',
			saveData: function(data){
				url= '/rbsmbl/x-services/tobacco/familyinfo';
				return this.post({
					'payload': data
				});
			},
			saveDataDep: function(data){
				url = '/rbsmbl/x-services/tobacco/individualinfo';
				return this.post({
					'payload': data
				});
			}
		});
	}]);
};


